.results {
  margin-bottom: 1.5rem;
  padding: 0.5rem 1rem 1rem 1rem;
  border-radius: 5px;
  border-top-left-radius: 0;
  background-color: var(--brand-grayscale-100);
}
